import React from 'react';

const Separator = () => (
  <svg width="100%" height="8" viewBox="0 0 1091 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 4H1087" stroke="#84BD00" strokeWidth="7" strokeLinecap="round"/>
  </svg>
);

export default Separator;
